const ORDER_REQUEST_STORAGE_PREFIX = "tea-shop-2b:pending-order:"
const pendingOrderRequestIds = new Map<string, string>()

function canonicalize(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonicalize)
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, entry]) => entry !== undefined)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, entry]) => [key, canonicalize(entry)]),
    )
  }
  return value
}

export function buildOrderRequestFingerprint(scope: string, payload: unknown) {
  return `${scope}:${JSON.stringify(canonicalize(payload))}`
}

function storageKey(fingerprint: string) {
  let first = 0x811C9DC5
  let second = 0x9E3779B9
  for (let index = 0; index < fingerprint.length; index += 1) {
    const code = fingerprint.charCodeAt(index)
    first = Math.imul(first ^ code, 0x01000193)
    second = Math.imul(second ^ (code + index), 0x85EBCA77)
  }
  return `${ORDER_REQUEST_STORAGE_PREFIX}${fingerprint.length}-${(first >>> 0).toString(16)}-${(second >>> 0).toString(16)}`
}

function currentSessionStorage(): Storage | undefined {
  try {
    return typeof sessionStorage === "undefined" ? undefined : sessionStorage
  }
  catch {
    return undefined
  }
}

function createOrderRequestId() {
  const randomPart = globalThis.crypto?.randomUUID?.()
    || Math.random().toString(36).slice(2)
  return `order-${Date.now().toString(36)}-${randomPart}`.slice(0, 64)
}

export function getOrCreateOrderRequestId(fingerprint: string) {
  const key = storageKey(fingerprint)
  let persisted: string | null | undefined
  try {
    persisted = currentSessionStorage()?.getItem(key)
  }
  catch {
    persisted = undefined
  }
  const existing = persisted || pendingOrderRequestIds.get(key)
  if (existing) return existing
  const requestId = createOrderRequestId()
  pendingOrderRequestIds.set(key, requestId)
  try {
    currentSessionStorage()?.setItem(key, requestId)
  }
  catch {
    // sessionStorage 不可用时保留模块级幂等键。
  }
  return requestId
}

export function clearOrderRequestId(fingerprint: string) {
  const key = storageKey(fingerprint)
  pendingOrderRequestIds.delete(key)
  try {
    currentSessionStorage()?.removeItem(key)
  }
  catch {
    // 清理失败不影响已完成订单。
  }
}
